import { CategoryId, IPublicationFilters } from '@pressreader/catalog-types';

import { IPublicationFiltersRequest } from './types';

const multiValueSeparator = ',';

function isNestedCategories(inCategories: CategoryId[] | CategoryId[][]): inCategories is CategoryId[][] {
    return Array.isArray(inCategories[0]);
}

function packBoolFilter<K extends 'supplement' | 'free' | 'cre' | 'availability'>(
    filters: IPublicationFiltersRequest,
    name: K,
    value: boolean | null | undefined,
) {
    if (value === true) {
        filters[name] = '1';
    } else if (value === false) {
        filters[name] = '0';
    }
}

function mapPublicationFilters(filters: IPublicationFilters | undefined): IPublicationFiltersRequest {
    const request: IPublicationFiltersRequest = {};
    if (!filters) {
        return request;
    }

    if (filters.mainCid) {
        request.main = filters.mainCid;
    }
    if (filters.text) {
        request.q = filters.text;
    }
    if (filters.publisherId) {
        request.publisherId = filters.publisherId;
    }
    if (filters.startsWith) {
        request.StartsWith = filters.startsWith;
    }
    if (filters.cids?.length) {
        request.cid = filters.cids.join(multiValueSeparator);
    }
    if (filters.hasCategories?.length) {
        request.has = filters.hasCategories.join(multiValueSeparator);
    }
    if (filters.excCategories?.length) {
        request.exc = filters.excCategories.join(multiValueSeparator);
    }
    if (filters.inCategories?.length) {
        // new model - array of arrays
        if (isNestedCategories(filters.inCategories)) {
            request.in = filters.inCategories.map(values => values.join(multiValueSeparator));
        } else {
            request.in = filters.inCategories.join(multiValueSeparator);
        }
    }
    packBoolFilter(request, 'supplement', filters.isSupplement);
    packBoolFilter(request, 'free', filters.isFree);
    packBoolFilter(request, 'cre', filters.cre);
    packBoolFilter(request, 'availability', filters.available);

    if (filters.releaseFrequency) {
        request.releaseFrequency = String(filters.releaseFrequency);
    }
    if (filters.issueDate) {
        request.issueDate = filters.issueDate;
    }

    return request;
}

export { mapPublicationFilters };
